export const tabsData = [
  {
    name: "Competency Assessments",
  },
  {
    name: "Cognitive Ability Assessments",
  },
  {
    name: "Aptitude Assessments",
  },
];

export const CompetenciesFields = [
  { name: "Future Focused" },
  { name: "Getting Things Done" },
  { name: "Working With Others" },
  { name: "Leading Others" },
  { name: "Self Mastery" },
];

export const FutureFocusData = [
  {
    url: "/media/home/sjts/externalorientation.png",
    name: "External Orientation",
    shortDescription:
      "External orientation refers to the exposure and engagement with the external world such as customers or networks to drive business.",
    bubbleDescription:
      "Real Estate Agent, Entrepreneur, Mortgage Broker, Sales, Business Development Manager, Journalism, Public Relations, Consulting",
    btnName: "Add Test",
    competency: {
      title: "The Full Circle",
      componentId: "external-orientation",
      description: "SJT - External Orientation",
      timer: "60",
      nextComponentId: "task-center",
      state: "open",
      type: "SJT",
      active: "TRUE",
      dataURL: "./assets/jsons/sjt/externalorientation.json",
      assetsURL: "./assets/images/campaign/sjts/externalorientation/",
    },
  },
  {
    url: "/media/home/sjts/imagination.png",
    name: "Imagination",
    shortDescription:
      "Imagination refers to the tendency to generate or recognize ideas or possibilities to produce new solutions to problems.",
    bubbleDescription:
      "Industrial Designers, Entrepreneur, Architects, Multimedia Artists and Animators, Fashion designers, Marketing manager, User experience (UX) designer, User interface (UI) designer.",
    btnName: "Add Test",
    competency: {
      title: "Slingshot",
      componentId: "imagination",
      description: "SJT - Imagination",
      timer: "60",
      nextComponentId: "task-center",
      dataURL: "./assets/jsons/sjt/imagination.json",
      assetsURL: "./assets/images/campaign/sjts/imagination/",
      state: "open",
      type: "SJT",
      active: "TRUE",
    },
  },
  {
    url: "/media/home/sjts/strategicthinking.png",
    name: "Strategic Thinking",
    shortDescription:
      "Strategic thinking is the ability to plan for the future and anticipate forthcoming challenges to be able to solve complex problems.",
    bubbleDescription:
      "Entrepreneur, Customer solution specialists, Content marketing specialists, Business consultant, Business analyst, Planning analysts, Research project manager, Technical product manager.",
    btnName: "Add Test",
    competency: {
      componentId: "strategic-thinking",
      title: "The Big Move",
      description: "SJT - Strategic Thinking",
      timer: "60",
      nextComponentId: "task-center",
      dataURL: "./assets/jsons/sjt/strategicthinking.json",
      assetsURL: "./assets/images/campaign/sjts/strategicthinking/",
      state: "open",
      type: "SJT",
      active: "TRUE",
    },
  },
  {
    url: "/media/home/sjts/innovation.png",
    name: "Innovation",
    shortDescription:
      "Innovation refers to the process of putting creative ideas into practice to create new value, processes, or products.",
    bubbleDescription:
      "Design & Communication, Biomedical Engineers, Software Developers, Architects, Medical Scientists, Marketing Manager, Health Specialist.",
    btnName: "Add Test",
    competency: {
      title: "New Horizon",
      componentId: "innovation",
      description: "SJT - Innovation",
      timer: "60",
      nextComponentId: "task-center",
      dataURL: "./assets/jsons/sjt/innovation.json",
      assetsURL: "./assets/images/campaign/sjts/innovation/",
      state: "open",
      type: "SJT",
      active: "TRUE",
    },
  },
];

export const ThingsDoneData = [
  {
    url: "/media/home/sjts/entrepreneurship.png",
    name: "Entrepreneurship",
    shortDescription:
      "Entrepreneurship refers to the ability and enthusiasm to take risks to develop, organize and run a business enterprise.",
    bubbleDescription:
      "Financial manager, Research and Development, Chief executive officer, Financial advisor, Sales representative, Advertising executive, Product manager, Real estate broker, Project manager",
    btnName: "Add Test",
    competency: {
      title: "Daredevil",
      componentId: "entrepreneurship",
      description: "SJT - Entrepreneurship",
      timer: "60",
      nextComponentId: "task-center",
      dataURL: "./assets/jsons/sjt/entrepreneurship.json",
      assetsURL: "./assets/images/campaign/sjts/entrepreneurship/",
      state: "open",
      type: "SJT",
      active: "TRUE",
    },
  },
  {
    url: "/media/home/sjts/driveforresults.png",
    name: "Drive For Results",
    shortDescription:
      "Drive for results refers to maintaining high levels of effectiveness and determination to deliver peak results/goals.",
    bubbleDescription:
      " Sales representative, General manager, Engineer, Chef, Scientist, Healthcare worker, Business Development Officer. Account Executive, Outbound Sales Representative",
    btnName: "Add Test",
    competency: {
      title: "And, Action!",
      componentId: "drive-for-results",
      description: "SJT - Drive For Results",
      timer: "60",
      nextComponentId: "task-center",
      dataURL: "./assets/jsons/sjt/driveforresults.json",
      assetsURL: "./assets/images/campaign/sjts/driveforresults/",
      state: "open",
      type: "SJT",
      active: "TRUE",
    },
  },
  {
    url: "/media/home/sjts/customerfocus.png",
    name: "Customer Focused",
    shortDescription:
      "Customer focus refers to a strategy that puts the customers' needs first and aligns business processes with their expectations.",
    bubbleDescription:
      "Call Center/Customer Support Representative, Care Support Coordinator, Receptionist,  IT technician, Support specialist, Network engineer HR Shared Services Coordinator",
    btnName: "Add Test",
    competency: {
      timer: "60",
      nextComponentId: "task-center",
      state: "open",
      type: "SJT",
      active: "TRUE",
      title: "Damaged Goods",
      componentId: "customer-focus",
      description: "SJT - Customer Focus",
      dataURL: "./assets/jsons/sjt/customerfocus.json",
      assetsURL: "./assets/images/campaign/sjts/customerfocus/",
    },
  },
  {
    url: "/media/home/sjts/planning.png",
    name: "Planning",
    shortDescription:
      "Planning refers to the process of setting objectives, targets, and formulating a plan to accomplish them.",
    bubbleDescription:
      "Event coordinator, Program coordinators, Executive assistant, Urban planner, Operations manager, Project manager, Logistics/distribution manager",
    btnName: "Add Test",
    competency: {
      timer: "60",
      nextComponentId: "task-center",
      state: "open",
      type: "SJT",
      active: "TRUE",
      title: "Fix'Em Up",
      componentId: "planning",
      description: "SJT - Planning",
      dataURL: "./assets/jsons/sjt/planning.json",
      assetsURL: "./assets/images/campaign/sjts/planning/",
    },
  },
];

export const WorkingWithOthers = [
  {
    url: "/media/home/sjts/collaboration.png",
    name: "Collaboration",
    shortDescription:
      "Collaboration alludes to the ability of individuals to work together for a common purpose to achieve business benefit.",
    bubbleDescription:
      "Consulting, Market research, Information technology/network security, Warehouse Workers, Assemblers, Administrative Assistants , Product Manager, Public Relations Specialist, Environmental Engineer.",
    btnName: "Add Test",
    competency: {
      timer: "60",
      nextComponentId: "task-center",
      state: "open",
      type: "SJT",
      active: "TRUE",
      title: "Boomerang",
      componentId: "collaboration",
      description: "SJT - Collaboration",
      dataURL: "./assets/jsons/sjt/collaboration.json",
      assetsURL: "./assets/images/campaign/sjts/collaboration/",
    },
  },
  {
    url: "/media/home/sjts/effectivecommunication.png",
    name: "Effective Communication",
    shortDescription:
      "Effective Communication is the ability to listen attentively and convey information in an articulate, clear and concise manner.",
    bubbleDescription:
      "Counselling psychologists, Customer service representatives, Medical assistants, Physical therapists, Public relations specialists, Social workers, Teachers, Training and development specialists.",
    btnName: "Add Test",
    competency: {
      timer: "60",
      nextComponentId: "task-center",
      state: "open",
      type: "SJT",
      active: "TRUE",
      title: "Picture Perfect",
      componentId: "effective-communication",
      description: "SJT - Effective Communication",
      dataURL: "./assets/jsons/sjt/effectivecommunication.json",
      assetsURL: "./assets/images/campaign/sjts/effectivecommunication/",
    },
  },
  {
    url: "/media/home/sjts/influence.png",
    name: "Influence",
    shortDescription:
      "Influence refers to the ability to shape or transform others’ beliefs and actions to gain their support and drive positive results.",
    bubbleDescription:
      "Project manager, Business Operations manager, External auditor, Sales Market Leader, Marketing manager, Chief executive Public relations and fundraising manager.",
    btnName: "Add Test",
    competency: {
      title: "Savvy",
      componentId: "influence",
      description: "SJT - Influence",
      timer: "60",
      nextComponentId: "task-center",
      dataURL: "./assets/jsons/sjt/influence.json",
      assetsURL: "./assets/images/campaign/sjts/influence/",
      state: "open",
      type: "SJT",
      active: "TRUE",
    },
  },
  {
    url: "/media/home/sjts/colormatch.png",
    name: "Valuing Diversity",
    shortDescription:
      "Valuing diversity refers to acknowledging the differences between people and using their differences as an asset.",
    bubbleDescription:
      "Advertising and promotions managers, Psychologists, Director of Culture.",
    btnName: "Add Test",
    competency: {
      timer: "60",
      nextComponentId: "task-center",
      state: "open",
      type: "SJT",
      active: "TRUE",
      title: "Anyone? Everyone!",
      componentId: "valuing-diversity",
      description: "SJT - Valuing Diversity",
      dataURL: "./assets/jsons/sjt/valuing-diversity.json",
      assetsURL: "./assets/images/campaign/sjts/valuingdiversity/",
    },
  },
];

export const leadingOthers = [
  {
    url: "/media/home/sjts/setdirection.png",
    name: "Set Direction",
    shortDescription:
      "Set direction refers to the ability to set clear performance standards that you expect you team to meet and deliver them over time.",
    bubbleDescription:
      "Setting direction allows the team to know what to expect. It reduces speculation about what to do and clarifies the path forward.",
    btnName: "Add Test",
    competency: {
      timer: "60",
      nextComponentId: "task-center",
      state: "open",
      type: "SJT",
      active: "TRUE",
      title: "It Happens",
      componentId: "set-direction",
      description: "SJT - Set Direction",
      dataURL: "./assets/jsons/sjt/setdirection.json",
      assetsURL: "./assets/images/campaign/sjts/setdirection/",
    },
  },
  {
    url: "/media/home/sjts/delegation.png",
    name: "Delegation",
    shortDescription:
      "Delegation refers to empowering employees by giving them the decision making power or task responsibility to maximize the organization's and individual effectiveness.",
    bubbleDescription:
      "Delegation helps you as a leader and your team develop as professionals, prepares you to manage larger teams, and inspires employees and team members to perform better.",
    btnName: "Add Test",
    competency: {
      title: "Sum Of Its Parts",
      componentId: "delegation",
      description: "SJT - Delegation",
      timer: "60",
      nextComponentId: "task-center",
      dataURL: "./assets/jsons/sjt/delegation.json",
      assetsURL: "./assets/images/campaign/sjts/delegation/",
      state: "open",
      type: "SJT",
      active: "TRUE",
    },
  },
  {
    url: "/media/home/sjts/developothers.png",
    name: "Develop Others",
    shortDescription:
      "Develop others refers to constructively reviewing the work of others in order to improve and advance their skills, knowledge, and performance.",
    bubbleDescription:
      "Develop others is useful for recognizing weaker sections and converting them into potential successes. It promotes their professional and personal growth.",
    btnName: "Add Test",
    competency: {
      timer: "60",
      nextComponentId: "task-center",
      state: "open",
      type: "SJT",
      active: "TRUE",
      title: "Let's Grow",
      componentId: "develop-others",
      description: "SJT - Develop Others",
      dataURL: "./assets/jsons/sjt/developothers.json",
      assetsURL: "./assets/images/campaign/sjts/developothers/",
    },
  },
  {
    url: "/media/home/sjts/recognition.png",
    name: "Recognition",
    shortDescription:
      "Recognition refers to the ability to create an environment where individuals are rewarded and praised for their contribution and talents.",
    bubbleDescription:
      "Recognition helps employees see that their company values them and their contributions to the success of the company. It builds a sense of security, motivating them to continue great work.",
    btnName: "Add Test",
    competency: {
      title: "Oh My!",
      componentId: "recognition",
      description: "SJT - Recognition",
      timer: "60",
      nextComponentId: "task-center",
      dataURL: "./assets/jsons/sjt/recognition.json",
      assetsURL: "./assets/images/campaign/sjts/recognition/",
      state: "open",
      type: "SJT",
      active: "TRUE",
    },
  },
];

export const selfMastery = [
  {
    url: "/media/home/sjts/agility.png",
    name: "Agility",
    shortDescription:
      "Agility refers to navigating change in a dynamic and ambiguous environment while embracing game-altering opportunities resulting from those.",
    bubbleDescription:
      "Agile employees tend to focus on fewer, more critical activities. As a result, they identify and work on more important tasks, streamlining activities, and cutting out unnecessary tasks.",
    btnName: "Add Test",
    competency: {
      timer: "60",
      nextComponentId: "task-center",
      state: "open",
      type: "SJT",
      active: "TRUE",
      title: "That's My Problem",
      componentId: "agility",
      description: "SJT - Agility",
      dataURL: "./assets/jsons/sjt/agility.json",
      assetsURL: "./assets/images/campaign/sjts/agility/",
    },
  },
  {
    url: "/media/home/sjts/character.png",
    name: "Character",
    shortDescription:
      "Character refers to the ability to display personal integrity and courage regardless of the possible adverse consequences.",
    bubbleDescription:
      "This is essential to establishing solid work relationships that are built on trust. It is vital to decision-making, serving customers, and managing employees.",
    btnName: "Add Test",
    competency: {
      timer: "60",
      nextComponentId: "task-center",
      state: "open",
      type: "SJT",
      active: "TRUE",
      title: "When Have I Ever?",
      componentId: "character",
      description: "SJT - Character",
      dataURL: "./assets/jsons/sjt/character.json",
      assetsURL: "./assets/images/campaign/sjts/character/",
    },
  },
  {
    url: "/media/home/sjts/perseverance.png",
    name: "Perseverance",
    shortDescription:
      "Perseverance refers to the continuous effort to achieve results despite difficulties, or opposition and being ready to endure for the long haul.",
    bubbleDescription:
      "Persevering people demonstrate resilience to obstacles in their way and persist tirelessly toward their set goals. They understand how to deal with failures and convert them into successes.",
    btnName: "Add Test",
    competency: {
      title: "Bedrock",
      componentId: "perseverance",
      description: "SJT - Perseverance",
      timer: "60",
      nextComponentId: "task-center",
      dataURL: "./assets/jsons/sjt/perseverance.json",
      assetsURL: "./assets/images/campaign/sjts/perseverance/",
      state: "open",
      type: "SJT",
      active: "TRUE",
    },
  },
  {
    url: "/media/home/sjts/investinginself.png",
    name: "Investing In Self",
    shortDescription:
      "Investing in self refers to the ability to take on new learnings, and therefore increase abilities, knowledge, and achievement.",
    bubbleDescription:
      "Investing in self enables employees to set challenging or stretch goals. It encourages them to take on new challenges that break them out of their comfort zone and bring about improvement.",
    btnName: "Add Test",
    competency: {
      timer: "60",
      nextComponentId: "task-center",
      state: "open",
      type: "SJT",
      active: "TRUE",
      title: "Now What",
      componentId: "investing-in-self",
      description: "SJT - Investing In Self",
      dataURL: "./assets/jsons/sjt/investinginself.json",
      assetsURL: "./assets/images/campaign/sjts/investinginself/",
    },
  },
];

export const CognitiveData = [
  {
    url: "/media/home/handemright.png",
    name: "Working Memory",
    shortDescription:
      "Working memory is a data processing function in which the brain constantly captures, stores, manipulates and recalls information to make it readily available for a brief period of time.",
    bubbleDescription:
      "Radio or television announcer, Adult basic- and secondary-education and literacy teacher or instructor, Environmental engineer, Bioinformatics scientist, Robotics engineer",
    btnName: "Add Test",
    competency: {
      title: "Hand Em Right ",
      description: "Minigame - Hand Em Right",
      timer: "60",
      componentId: "handemright",
      nextComponentId: "task-center",
      url: "./minigames/handemright/app.bundle.js",
      startupData: `{"horizontal": "./assets/minigameBG/minigameBG.png"}`,
      assetsURL: "./minigames/handemright",
      state: "open",
      type: "Minigame",
      active: "TRUE",
    },
  },
  {
    url: "/media/home/flipflop.png",
    name: "Cognitive Flexibility",
    shortDescription:
      "Cognitive flexibility is the capacity to switch between different tasks or goals, enabling one to think divergently, change perspectives and quickly adapt to a new changing environment.",
    bubbleDescription:
      "Entrepreneur, PR/Media Production, Consultant, Journalist, Sales/Business Development, Marketing teams, Artists, Customer support",
    btnName: "Add Test",
    competency: {
      title: "Flip Flop ",
      description: "Minigame - Flip Flop",
      timer: "60",
      componentId: "flipflop",
      nextComponentId: "task-center",
      url: "./minigames/flipflop/app.bundle.js",
      startupData: `{"horizontal": "./assets/minigameBG/minigameBG.png"}`,
      assetsURL: "./minigames/flipflop",
      state: "open",
      type: "Minigame",
      active: "TRUE",
    },
  },
  {
    url: "/media/home/boxsort.png",
    name: "Divided Attention",
    shortDescription:
      "Divided attention refers to the ability to respond to different competing stimuli at the same time. It is the performance of multiple tasking.",
    bubbleDescription:
      "Event Planner, Administrative Assistant, Nurse, Assembly Line Operator, Customer Service Representative, Receptionist, Bank Teller, Chef, Project Manager, Warehouse and Distribution Manager.",
    btnName: "Add Test",
    competency: {
      title: "Box Sort ",
      description: "Minigame - Box Sort",
      timer: "60",
      componentId: "boxsort",
      nextComponentId: "task-center",
      url: "./minigames/boxsort/app.bundle.js",
      startupData: `{"horizontal": "./assets/minigameBG/minigameBG.png"}`,
      assetsURL: "./minigames/boxsort",
      state: "open",
      type: "Minigame",
      active: "TRUE",
    },
  },
  {
    url: "/media/home/colormatch.png",
    name: "Inhibitory Control",
    shortDescription:
      "Inhibitory control is the ability to limit the influence of unwanted emotions, thoughts and behaviors to achieve the setting targets. ",
    bubbleDescription:
      "Special Education Teachers, Licensed Practical Nurse, Mental Health Counselor, Police and Sheriff's Patrol Officers, Human Resources Managers, Data Entry Keyers, First-Line Supervisors of Retail Sales Workers ",
    btnName: "Add Test",
    competency: {
      title: "Color Match ",
      description: "Minigame - Color Match",
      timer: "60",
      componentId: "colormatch",
      nextComponentId: "task-center",
      url: "./minigames/colormatch/app.bundle.js",
      startupData: `{"horizontal": "./assets/minigameBG/minigameBG.png"}`,
      assetsURL: "./minigames/colormatch",
      state: "open",
      type: "Minigame",
      active: "TRUE",
    },
  },
  {
    url: "/media/home/moneycount.png",
    name: "Updating",
    shortDescription:
      "Updating is the ability of the mind to continuously refresh or delete contents in working memory to ensure one's behaviors are consistent with the plan of action. ",
    bubbleDescription:
      "EMTs (emergency medical technicians), Package Handler, Sales Manager.",
    btnName: "Add Test",
    competency: {
      title: "Money Count",
      description: "Minigame - Money Count",
      timer: "60",
      componentId: "moneycount",
      nextComponentId: "task-center",
      url: "./minigames/moneycount/app.bundle.js",
      startupData: `{"horizontal": "./assets/minigameBG/minigameBG.png"}`,
      assetsURL: "./minigames/moneycount",
      state: "open",
      type: "Minigame",
      active: "TRUE",
    },
  },
  {
    url: "/media/home/moneysort.png",
    name: "Sustained Attention",
    shortDescription:
      "Sustained attention is the ability to focus on an action or activity for long periods of time, concentrating on it and taking it to completion even in a distracting environment. ",
    bubbleDescription:
      "Gaming Surveillance Officers and Gaming Investigators, Dentists, Mental Health Counselors, Translator/interpreters,  Surgeon,  Surgical Technologists,  Pilots.",
    btnName: "Add Test",
    competency: {
      title: "Money Sort ",
      description: "Minigame - Money Sort",
      timer: "60",
      componentId: "moneysort",
      nextComponentId: "task-center",
      url: "./minigames/moneysort/app.bundle.js",
      startupData: `{"horizontal": "./assets/minigameBG/minigameBG.png"}`,
      assetsURL: "./minigames/moneysort",
      state: "open",
      type: "Minigame",
      active: "TRUE",
    },
  },
  {
    url: "/media/home/makeway.png",
    name: "Planning",
    shortDescription:
      "Planning is a fundamental cognitive function that involves thinking ahead, evaluating options, and choosing the best course of action.",
    bubbleDescription:
      "Product managers & owners, Engineers, Sales representatives, Travel agent, Librarian, Event planner, Interior designer, General manager, Training and development specialist , Project manager, Lawyer, financial advisors.",
    btnName: "Add Test",
    competency: {
      title: "Make Way ",
      description: "Minigame - Make Way",
      timer: "60",
      componentId: "makeway",
      nextComponentId: "task-center",
      url: "./minigames/makeway/app.bundle.js",
      startupData: `{"horizontal": "./assets/minigameBG/minigameBG.png"}`,
      assetsURL: "./minigames/makeway",
      state: "open",
      type: "Minigame",
      active: "TRUE",
    },
  },
  {
    url: "/media/home/binder.png",
    name: "Focused Attention",
    shortDescription:
      "Focused attention is the ability to accurately and thoroughly direct attention to, and respond to a specific stimulus. The stimuli may be auditory, visual, tactile, or cognitive.",
    bubbleDescription:
      "Software developers, Editors, Customer success representatives, Engineers, Data analyst/data scientist, Quality assurance and compliance, Accountant, Personal assistant, Video editors",
    btnName: "Add Test",
    competency: {
      title: "Binder ",
      description: "Minigame - Binder",
      timer: "60",
      componentId: "binder",
      nextComponentId: "task-center",
      url: "./minigames/binder/app.bundle.js",
      startupData: `{"horizontal": "./assets/minigameBG/minigameBG.png"}`,
      assetsURL: "./minigames/binder",
      state: "open",
      type: "Minigame",
      active: "TRUE",
    },
  },
  {
    url: "/media/home/cypher.png",
    name: "Information Processing",
    shortDescription:
      "Information processing speed refers to the speed with which information can be sensed, perceived, understood, and then responded to.",
    bubbleDescription:
      "Emergency responders (e.g., paramedics, firefighters, police officers) Air traffic controllers Surgeons and other medical professionals Military personnel Stock traders and financial analysts Data analysts and researchers Customer service representatives.",
    btnName: "Add Test",
    competency: {
      title: "Cypher ",
      description: "Minigame - Cypher",
      timer: "60",
      componentId: "cypher",
      nextComponentId: "task-center",
      url: "./minigames/cypher/app.bundle.js",
      startupData: `{"horizontal": "./assets/minigameBG/minigameBG.png"}`,
      assetsURL: "./minigames/cypher",
      state: "open",
      type: "Minigame",
      active: "TRUE",
    },
  },
];

export const aptitudeData = [
  {
    url: "/media/home/lightsout.png",
    name: "English Verbal Reasoning",
    shortDescription:
      "The Verbal Reasoning assesses a person's ability to understand, analyze, and interpret written information.",
    bubbleDescription:
      "Verbal Reasoning skills develop qualities such as perception, understanding and solving complicated subject questions, empathy and logical reasoning as well as ensuring a great vocabulary.",

    btnName: "Add Test",
    competency: {
      title: "Light's Out ",
      description: "Minigame - Lights Out",
      timer: "60",
      componentId: "lightsout",
      nextComponentId: "task-center",
      url: "./minigames/lightsout/app.bundle.js",
      startupData: `{"horizontal": "./assets/minigameBG/minigameBG.png"}`,
      assetsURL: "./minigames/lightsout",
      state: "open",
      type: "Minigame",
      active: "TRUE",
    },
  },
  {
    url: "/media/home/parkit.png",
    name: "Numerical Logic",
    shortDescription:
      "Numerical Logic assess logical thinking ability. They are designed to evaluate the degree to which you can think clearly and analytically to solve the problems.",
    bubbleDescription:
      "Auditor, Accountant, Purchasing agent, Underwriter, Mathematician, Scientist, Statistician, Actuary.",

    btnName: "Add Test",
    competency: {
      title: "Park It ",
      description: "Minigame - Park It",
      timer: "60",
      componentId: "parkit",
      nextComponentId: "task-center",
      url: "./minigames/parkit/app.bundle.js",
      startupData: `{"horizontal": "./assets/minigameBG/minigameBG.png"}`,
      assetsURL: "./minigames/parkit",
      state: "open",
      type: "Minigame",
      active: "TRUE",
    },
  },
  {
    url: "/media/home/amnesia.png",
    name: "Inductive Reasoning",
    shortDescription:
      "Inductive reasoning is the ability to identify and interpret patterns. They have been found to have a high correlation with general intelligence and the ability to reason logically.",
    bubbleDescription:
      "Engineering, science and IT roles, including software development jobs.",
    btnName: "Add Test",
    competency: {
      title: "Amnesia ",
      description: "Minigame - Amnesia",
      timer: "60",
      componentId: "amnesia",
      nextComponentId: "task-center",
      url: "./minigames/amnesia/app.bundle.js",
      startupData: `{"horizontal": "./assets/minigameBG/minigameBG.png"}`,
      assetsURL: "./minigames/amnesia",
      state: "open",
      type: "Minigame",
      active: "TRUE",
    },
  },
  {
    url: "/media/home/numberrush.png",
    name: "Basic Arithmetic",
    shortDescription:
      "Basic Arithmetic are skills and knowledge of the most basic mathematics. ",
    bubbleDescription:
      "Math skills involve making calculations with numbers, data and percentages, and are useful for a variety of job functions such as salaries, budgets and presentations.",
    btnName: "Add Test",
    competency: {
      title: "Number Rush",
      description: "Minigame - Number Rush",
      timer: "60",
      componentId: "numberrush",
      nextComponentId: "task-center",
      url: "./minigames/numberrush/bundle.js",
      startupData: `{"horizontal": "./assets/minigameBG/minigameBG.png"}`,
      assetsURL: "./minigames/numberrush",
      state: "open",
      type: "Minigame",
      active: "TRUE",
    },
  },
];

export const defaultHintMessage =
  "Find out more details about the competencies by clicking on the (i) icon on each of the thumbnails (images).";
